import React, { useState } from 'react';
import {
    EuiCard,
    EuiCollapsibleNavGroup,
    EuiFlexGroup,
    EuiFlexItem,
    EuiIcon,
    EuiTitle,
    EuiText,
    EuiSpacer,
    EuiButton,
    EuiButtonIcon,
    EuiFormRow,
    EuiRadioGroup,
} from '@elastic/eui';
import { useFieldArray, Controller } from 'react-hook-form';
import SwitchField from '../../../../components/Form/SwitchField';
import NumberField from '../../../../components/Form/NumberField';
import CheckBoxField from '../../../../components/Form/CheckBoxField';

const GamificationSettings = ({ control, errors, watch, setValue, selectedSystem }) => {
    const [isNavOpen, setIsNavOpen] = useState(true);

    console.log('[GamificationSettings] Component mounted/re-rendered');
    console.log('[GamificationSettings] setValue function:', typeof setValue, setValue ? 'exists' : 'missing');
    console.log('[GamificationSettings] control object:', typeof control, control ? 'exists' : 'missing');

    const {
        fields: streakFields,
        append: appendStreak,
        remove: removeStreak,
    } = useFieldArray({
        control,
        name: 'streak_rewards',
    });

    const rewardUnit = selectedSystem === 'cashback' ? '₹' : 'points';

    const dailyRewardOptions = [
        { id: 'scratch_card', label: 'Scratch Card' },
        { id: 'spin_wheel', label: 'Spin Wheel' },
    ];

    const probabilityModeOptions = [
        { id: 'manual', label: 'Manual' },
        { id: 'advanced', label: 'Advanced Settings' },
    ];

    // Store watched values in variables to avoid multiple calls
    const enableDailyRewards = watch('enable_daily_rewards');
    const enableStreaks = watch('enable_streaks');
    const enableReferralChallenge = watch('enable_referral_challenge');
    const enableOrderFrequencyChallenge = watch('enable_order_frequency_challenge');
    const enableOrderDiversityChallenge = watch('enable_order_diversity_challenge');
    const enableProfileCompletionChallenge = watch('enable_profile_completion_challenge');

    // Watch the daily reward mechanism separately to ensure re-renders
    const dailyRewardMechanism = watch('daily_reward_mechanism');

    console.log('[GamificationSettings] Watching values - daily:', enableDailyRewards, 'streaks:', enableStreaks);
    console.log('[GamificationSettings] Daily reward mechanism:', dailyRewardMechanism);

    console.log('[GamificationSettings] All checkbox values:', {
        enable_daily_rewards: enableDailyRewards,
        enable_streaks: enableStreaks,
        enable_referral_challenge: enableReferralChallenge,
        enable_order_frequency_challenge: enableOrderFrequencyChallenge,
        enable_order_diversity_challenge: enableOrderDiversityChallenge,
        enable_profile_completion_challenge: enableProfileCompletionChallenge,
    });

    return (
        <EuiCard
            layout='horizontal'
            title={
                <EuiFlexGroup direction='row' justifyContent='spaceBetween' alignItems='center' gutterSize='xs'>
                    <EuiFlexItem grow={10}>
                        <EuiFlexGroup justifyContent='flexStart' alignItems='center' direction='row' gutterSize='s'>
                            <EuiFlexItem grow={false}>
                                <EuiIcon type='gameController' size='l' />
                            </EuiFlexItem>
                            <EuiFlexItem style={{ cursor: 'pointer' }} onClick={() => setIsNavOpen(!isNavOpen)}>
                                <EuiTitle size='s'>
                                    <h3>Gamification & Engagement</h3>
                                </EuiTitle>
                            </EuiFlexItem>
                        </EuiFlexGroup>
                    </EuiFlexItem>
                    <EuiFlexItem grow={false}>
                        <EuiButtonIcon
                            iconType={isNavOpen ? 'arrowUp' : 'arrowDown'}
                            onClick={() => setIsNavOpen(!isNavOpen)}
                            aria-label='Toggle gamification settings'
                        />
                    </EuiFlexItem>
                </EuiFlexGroup>
            }
        >
            <EuiCollapsibleNavGroup
                title={<></>}
                isCollapsible={true}
                initialIsOpen={isNavOpen}
                forceState={isNavOpen ? 'open' : 'closed'}
                arrowDisplay='none'
            >
                {/* Daily Rewards Section */}
                <EuiText size='m'>
                    <h4>Daily Rewards</h4>
                </EuiText>
                <EuiSpacer size='s' />

                <SwitchField
                    name='enable_daily_rewards'
                    defaultValue={enableDailyRewards || false}
                    control={control}
                    label='Enable Daily Rewards'
                    setValue={setValue}
                />

                {console.log(
                    '[GamificationSettings] Before Daily Rewards conditional - enableDailyRewards:',
                    enableDailyRewards
                )}
                {enableDailyRewards ? (
                    <>
                        {console.log('[GamificationSettings] Rendering Daily Rewards content')}
                        <EuiSpacer size='m' />

                        {console.log('[GamificationSettings] dailyRewardOptions:', dailyRewardOptions)}
                        {console.log(
                            '[GamificationSettings] Current daily_reward_mechanism value:',
                            dailyRewardMechanism
                        )}

                        <EuiFormRow label='Reward Mechanism'>
                            <Controller
                                name='daily_reward_mechanism'
                                control={control}
                                defaultValue='scratch_card'
                                render={({ field }) => {
                                    console.log(
                                        '[GamificationSettings] Radio Controller render - field.value:',
                                        field.value
                                    );
                                    return (
                                        <EuiRadioGroup
                                            options={dailyRewardOptions}
                                            idSelected={field.value}
                                            onChange={(id) => {
                                                console.log('[GamificationSettings] Radio button clicked - id:', id);
                                                console.log(
                                                    '[GamificationSettings] Current field.value before onChange:',
                                                    field.value
                                                );
                                                field.onChange(id);

                                                // Also use setValue to ensure the form state updates
                                                setValue('daily_reward_mechanism', id, {
                                                    shouldValidate: true,
                                                    shouldDirty: true,
                                                });

                                                console.log('[GamificationSettings] Called field.onChange with:', id);

                                                // Debug check after a delay
                                                setTimeout(() => {
                                                    console.log(
                                                        '[GamificationSettings] Value after field.onChange (delayed):',
                                                        watch('daily_reward_mechanism')
                                                    );
                                                }, 100);
                                            }}
                                            name='daily_reward_mechanism_radio'
                                        />
                                    );
                                }}
                            />
                        </EuiFormRow>

                        <EuiSpacer size='m' />

                        {console.log(
                            'Checking scratch card condition:',
                            dailyRewardMechanism,
                            '=== scratch_card?',
                            dailyRewardMechanism === 'scratch_card'
                        )}
                        {dailyRewardMechanism === 'scratch_card' && (
                            <>
                                {/* Probability Mode Selection */}
                                <EuiFormRow label='Probability Mode'>
                                    <Controller
                                        name='scratch_card_probability_mode'
                                        control={control}
                                        defaultValue='manual'
                                        render={({ field }) => (
                                            <EuiRadioGroup
                                                options={probabilityModeOptions}
                                                idSelected={field.value || 'manual'}
                                                onChange={(id) => {
                                                    field.onChange(id);
                                                    setValue('scratch_card_probability_mode', id, {
                                                        shouldValidate: true,
                                                        shouldDirty: true,
                                                    });
                                                }}
                                                name='scratch_card_probability_mode_radio'
                                            />
                                        )}
                                    />
                                </EuiFormRow>

                                <EuiSpacer size='m' />

                                {/* Reward Range with Probability */}
                                <EuiText size='s'>
                                    <p>Reward Range</p>
                                </EuiText>

                                <EuiFlexGroup gutterSize='m' alignItems='center'>
                                    <EuiFlexItem grow={false}>
                                        <NumberField
                                            label='Min'
                                            name='daily_reward_min'
                                            control={control}
                                            errors={errors}
                                            placeholder='0'
                                            rules={{
                                                required: 'Min value required',
                                                min: { value: 0, message: 'Cannot be negative' },
                                            }}
                                            compressed
                                        />
                                    </EuiFlexItem>
                                    <EuiFlexItem grow={false}>
                                        <NumberField
                                            label='Max'
                                            name='daily_reward_max'
                                            control={control}
                                            errors={errors}
                                            placeholder='10'
                                            rules={{
                                                required: 'Max value required',
                                                min: { value: 0, message: 'Cannot be negative' },
                                                validate: (value) => {
                                                    const min = watch('daily_reward_min');
                                                    return value >= min || 'Max must be greater than min';
                                                },
                                            }}
                                            compressed
                                        />
                                    </EuiFlexItem>
                                    {watch('scratch_card_probability_mode') === 'manual' && (
                                        <EuiFlexItem grow={false}>
                                            <NumberField
                                                label='Probability'
                                                name='scratch_card_manual_probability'
                                                control={control}
                                                errors={errors}
                                                placeholder='50'
                                                append='%'
                                                rules={{
                                                    required: 'Probability required',
                                                    min: { value: 0, message: 'Min 0%' },
                                                    max: { value: 100, message: 'Max 100%' },
                                                }}
                                                compressed
                                            />
                                        </EuiFlexItem>
                                    )}
                                    {/* <EuiFlexItem>
                                        <EuiText size='xs' color='subdued'>
                                            <p>(0 = "Try Again Tomorrow")</p>
                                        </EuiText>
                                    </EuiFlexItem> */}
                                </EuiFlexGroup>

                                <EuiSpacer size='s' />
                                <EuiText size='xs' color='subdued'>
                                    <p>* Reward type auto-determined by primary system ({rewardUnit})</p>
                                </EuiText>

                                {watch('scratch_card_probability_mode') === 'advanced' && (
                                    <>
                                        <EuiSpacer size='s' />
                                        <EuiText size='xs' color='subdued'>
                                            <p>
                                                * Probability will be automatically calculated based on the reward range
                                            </p>
                                        </EuiText>

                                        {/* Discount strategy information based on selected mode */}
                                        {(() => {
                                            const mode = watch('scratch_card_probability_mode');

                                            const discountStrategies = {
                                                conservative: {
                                                    title: 'Conservative Discounts',
                                                    data: [
                                                        {
                                                            range: '0%-4%',
                                                            discount: '45%',
                                                            value: '1 – 5',
                                                        },
                                                        { range: '5%-7%', discount: '32%', value: '6 – 9' },
                                                        { range: '8%-13%', discount: '13%', value: '10 – 18' },
                                                        { range: '14%-25%', discount: '9%', value: '19 – 27' },
                                                        { range: '26%-100%', discount: '1%', value: '27 – 100' },
                                                    ],
                                                },
                                                moderate: {
                                                    title: 'Moderate Discounts',
                                                    data: [
                                                        {
                                                            range: '0%-5%',
                                                            discount: '22%',
                                                            value: '1 – 5',
                                                        },
                                                        { range: '6%-9%', discount: '26%', value: '6 – 9' },
                                                        { range: '10%-18%', discount: '32%', value: '10 – 18' },
                                                        { range: '19%-27%', discount: '19%', value: '19 – 27' },
                                                        { range: '28%-100%', discount: '1%', value: '27 – 100' },
                                                    ],
                                                },
                                                aggressive: {
                                                    title: 'Aggressive Discounts',
                                                    data: [
                                                        {
                                                            range: '0%-6%',
                                                            discount: '12%',
                                                            value: '1 – 6',
                                                        },
                                                        { range: '7%-9%', discount: '16%', value: '7 – 9' },
                                                        { range: '10%-18%', discount: '33%', value: '10 – 18' },
                                                        { range: '19%-40%', discount: '36%', value: '19 – 40' },
                                                        { range: '41%-100%', discount: '3%', value: '41 – 100' },
                                                    ],
                                                },
                                            };

                                            const strategy = discountStrategies[mode];
                                            if (!strategy) return null;

                                            return (
                                                <>
                                                    <EuiSpacer size='m' />
                                                    <EuiCard
                                                        title={strategy.title}
                                                        titleSize='xs'
                                                        paddingSize='s'
                                                        style={{ backgroundColor: '#f5f7fa' }}
                                                    >
                                                        <EuiText size='xs'>
                                                            <table
                                                                style={{ width: '100%', borderCollapse: 'collapse' }}
                                                            >
                                                                <thead>
                                                                    <tr style={{ borderBottom: '1px solid #e3e4e5' }}>
                                                                        <th
                                                                            style={{
                                                                                textAlign: 'left',
                                                                                padding: '8px',
                                                                                fontWeight: '600',
                                                                            }}
                                                                        >
                                                                            Bill Amount (₹100 Example)
                                                                        </th>
                                                                        <th
                                                                            style={{
                                                                                textAlign: 'right',
                                                                                padding: '8px',
                                                                                fontWeight: '600',
                                                                            }}
                                                                        >
                                                                            Discount Mechanism
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {strategy.data.map((row, index) => (
                                                                        <tr
                                                                            key={index}
                                                                            style={{
                                                                                borderBottom:
                                                                                    index < strategy.data.length - 1
                                                                                        ? '1px solid #f2f3f3'
                                                                                        : 'none',
                                                                            }}
                                                                        >
                                                                            <td style={{ padding: '12px 8px' }}>
                                                                                ₹{row.value}
                                                                            </td>
                                                                            <td
                                                                                style={{
                                                                                    textAlign: 'right',
                                                                                    padding: '12px 8px',
                                                                                }}
                                                                            >
                                                                                {row.discount} chance
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </EuiText>
                                                    </EuiCard>
                                                </>
                                            );
                                        })()}
                                    </>
                                )}
                            </>
                        )}
                    </>
                ) : (
                    <>
                        {console.log(
                            '[GamificationSettings] NOT rendering Daily Rewards content - enableDailyRewards is:',
                            enableDailyRewards
                        )}
                    </>
                )}

                <EuiSpacer size='xl' />

                {/* Streak Bonuses Section */}
                <EuiText size='m'>
                    <h4>Streak Bonuses</h4>
                </EuiText>
                <EuiSpacer size='s' />

                <SwitchField
                    name='enable_streaks'
                    defaultValue={enableStreaks || false}
                    control={control}
                    label='Enable Streaks'
                    setValue={setValue}
                />

                {console.log('[GamificationSettings] Before Streaks conditional - enableStreaks:', enableStreaks)}
                {enableStreaks ? (
                    <>
                        {console.log('[GamificationSettings] Rendering Streaks content')}
                        <EuiSpacer size='m' />

                        <EuiCard title='Streak Rewards' titleSize='xs' paddingSize='s'>
                            <EuiFlexGroup direction='column' gutterSize='s'>
                                <EuiFlexItem>
                                    <EuiFlexGroup alignItems='center'>
                                        <EuiFlexItem grow={2}>
                                            <EuiText size='s'>
                                                <strong>Days</strong>
                                            </EuiText>
                                        </EuiFlexItem>
                                        <EuiFlexItem grow={4}>
                                            <EuiText size='s'>
                                                <strong>Reward</strong>
                                            </EuiText>
                                        </EuiFlexItem>
                                        <EuiFlexItem grow={false}>
                                            <EuiButton size='s' onClick={() => appendStreak({ days: '', reward: '' })}>
                                                Add
                                            </EuiButton>
                                        </EuiFlexItem>
                                    </EuiFlexGroup>
                                </EuiFlexItem>

                                {streakFields.map((field, index) => (
                                    <EuiFlexItem key={field.id}>
                                        <EuiFlexGroup alignItems='center'>
                                            <EuiFlexItem grow={2}>
                                                <NumberField
                                                    name={`streak_rewards.${index}.days`}
                                                    control={control}
                                                    errors={errors}
                                                    placeholder='7'
                                                    compressed
                                                    rules={{
                                                        required: 'Days required',
                                                        min: { value: 1, message: 'Min 1 day' },
                                                        max: { value: 365, message: 'Max 365 days' },
                                                    }}
                                                />
                                            </EuiFlexItem>
                                            <EuiFlexItem grow={4}>
                                                <NumberField
                                                    name={`streak_rewards.${index}.reward`}
                                                    control={control}
                                                    errors={errors}
                                                    placeholder='50'
                                                    append={rewardUnit}
                                                    compressed
                                                    rules={{
                                                        required: 'Reward required',
                                                        min: { value: 1, message: 'Min 1' },
                                                    }}
                                                />
                                            </EuiFlexItem>
                                            <EuiFlexItem grow={false}>
                                                <EuiButtonIcon
                                                    iconType='trash'
                                                    color='danger'
                                                    onClick={() => removeStreak(index)}
                                                    aria-label='Delete streak reward'
                                                />
                                            </EuiFlexItem>
                                        </EuiFlexGroup>
                                    </EuiFlexItem>
                                ))}
                            </EuiFlexGroup>
                        </EuiCard>
                    </>
                ) : (
                    <>
                        {console.log(
                            '[GamificationSettings] NOT rendering Streaks content - enableStreaks is:',
                            enableStreaks
                        )}
                    </>
                )}

                <EuiSpacer size='xl' />

                {/* Challenges Section */}
                <EuiText size='m'>
                    <h4>Challenges</h4>
                </EuiText>
                <EuiSpacer size='m' />

                {/* Referral Challenge */}
                <CheckBoxField
                    name='enable_referral_challenge'
                    defaultValue={enableReferralChallenge || false}
                    control={control}
                    label='Referral Challenge'
                    setValue={setValue}
                />
                {console.log(
                    '[GamificationSettings] Before Referral Challenge conditional - enableReferralChallenge:',
                    enableReferralChallenge
                )}
                {enableReferralChallenge ? (
                    <>
                        {console.log('[GamificationSettings] Rendering Referral Challenge content')}
                        <EuiFlexGroup gutterSize='m' alignItems='center'>
                            <EuiFlexItem grow={false}>
                                <EuiText size='s'>Reward:</EuiText>
                            </EuiFlexItem>
                            <EuiFlexItem grow={false}>
                                <NumberField
                                    name='referral_challenge_reward'
                                    control={control}
                                    errors={errors}
                                    placeholder='50'
                                    append={`${rewardUnit} per referral`}
                                    compressed
                                    rules={{
                                        required: 'Reward required',
                                        min: { value: 1, message: 'Min 1' },
                                    }}
                                />
                            </EuiFlexItem>
                        </EuiFlexGroup>
                        <EuiSpacer size='m' />
                    </>
                ) : null}

                {/* Order Frequency Challenge */}
                <CheckBoxField
                    name='enable_order_frequency_challenge'
                    defaultValue={enableOrderFrequencyChallenge || false}
                    control={control}
                    label='Order Frequency Challenge'
                    setValue={setValue}
                />
                {console.log(
                    '[GamificationSettings] Before Order Frequency Challenge conditional - enableOrderFrequencyChallenge:',
                    enableOrderFrequencyChallenge
                )}
                {enableOrderFrequencyChallenge ? (
                    <>
                        {console.log('[GamificationSettings] Rendering Order Frequency Challenge content')}
                        <EuiFlexGroup gutterSize='m' alignItems='center'>
                            <EuiFlexItem grow={false}>
                                <EuiText size='s'>Place</EuiText>
                            </EuiFlexItem>
                            <EuiFlexItem grow={false}>
                                <NumberField
                                    name='order_frequency_count'
                                    control={control}
                                    errors={errors}
                                    placeholder='5'
                                    compressed
                                    rules={{
                                        required: 'Count required',
                                        min: { value: 1, message: 'Min 1' },
                                    }}
                                />
                            </EuiFlexItem>
                            <EuiFlexItem grow={false}>
                                <EuiText size='s'>orders in</EuiText>
                            </EuiFlexItem>
                            <EuiFlexItem grow={false}>
                                <NumberField
                                    name='order_frequency_days'
                                    control={control}
                                    errors={errors}
                                    placeholder='7'
                                    append='days'
                                    compressed
                                    rules={{
                                        required: 'Days required',
                                        min: { value: 1, message: 'Min 1 day' },
                                    }}
                                />
                            </EuiFlexItem>
                        </EuiFlexGroup>
                        <EuiFlexGroup gutterSize='m' alignItems='center'>
                            <EuiFlexItem grow={false}>
                                <EuiText size='s'>Reward:</EuiText>
                            </EuiFlexItem>
                            <EuiFlexItem grow={false}>
                                <NumberField
                                    name='order_frequency_reward'
                                    control={control}
                                    errors={errors}
                                    placeholder='100'
                                    append={rewardUnit}
                                    compressed
                                    rules={{
                                        required: 'Reward required',
                                        min: { value: 1, message: 'Min 1' },
                                    }}
                                />
                            </EuiFlexItem>
                        </EuiFlexGroup>
                        <EuiSpacer size='m' />
                    </>
                ) : null}

                {/* Order Diversity Challenge */}
                <CheckBoxField
                    name='enable_order_diversity_challenge'
                    defaultValue={enableOrderDiversityChallenge || false}
                    control={control}
                    label='Order Diversity Challenge'
                    setValue={setValue}
                />
                {console.log(
                    '[GamificationSettings] Before Order Diversity Challenge conditional - enableOrderDiversityChallenge:',
                    enableOrderDiversityChallenge
                )}
                {enableOrderDiversityChallenge ? (
                    <>
                        {console.log('[GamificationSettings] Rendering Order Diversity Challenge content')}
                        <EuiText size='xs' color='subdued'>
                            <p>Complete one of each: Delivery, Dine-in, Takeaway</p>
                        </EuiText>
                        <EuiFlexGroup gutterSize='m' alignItems='center'>
                            <EuiFlexItem grow={false}>
                                <EuiText size='s'>Reward:</EuiText>
                            </EuiFlexItem>
                            <EuiFlexItem grow={false}>
                                <NumberField
                                    name='order_diversity_reward'
                                    control={control}
                                    errors={errors}
                                    placeholder='150'
                                    append={rewardUnit}
                                    compressed
                                    rules={{
                                        required: 'Reward required',
                                        min: { value: 1, message: 'Min 1' },
                                    }}
                                />
                            </EuiFlexItem>
                        </EuiFlexGroup>
                        <EuiSpacer size='m' />
                    </>
                ) : null}

                {/* Profile Completion Challenge */}
                <CheckBoxField
                    name='enable_profile_completion_challenge'
                    defaultValue={enableProfileCompletionChallenge || false}
                    control={control}
                    label='Profile Completion Challenge'
                    setValue={setValue}
                />
                {console.log(
                    '[GamificationSettings] Before Profile Completion Challenge conditional - enableProfileCompletionChallenge:',
                    enableProfileCompletionChallenge
                )}
                {enableProfileCompletionChallenge ? (
                    <>
                        {console.log('[GamificationSettings] Rendering Profile Completion Challenge content')}
                        <EuiText size='xs' color='subdued'>
                            <p>Complete profile with birthday & anniversary</p>
                        </EuiText>
                        <EuiFlexGroup gutterSize='m' alignItems='center'>
                            <EuiFlexItem grow={false}>
                                <EuiText size='s'>Reward:</EuiText>
                            </EuiFlexItem>
                            <EuiFlexItem grow={false}>
                                <NumberField
                                    name='profile_completion_reward'
                                    control={control}
                                    errors={errors}
                                    placeholder='25'
                                    append={rewardUnit}
                                    compressed
                                    rules={{
                                        required: 'Reward required',
                                        min: { value: 1, message: 'Min 1' },
                                    }}
                                />
                            </EuiFlexItem>
                        </EuiFlexGroup>
                    </>
                ) : null}
            </EuiCollapsibleNavGroup>
        </EuiCard>
    );
};

// Option 1: Remove React.memo completely
export default GamificationSettings;

// Option 2: If you want to keep React.memo, add dependencies
// export default React.memo(GamificationSettings, (prevProps, nextProps) => {
//     return (
//         prevProps.control === nextProps.control &&
//         prevProps.errors === nextProps.errors &&
//         prevProps.selectedSystem === nextProps.selectedSystem
//     );
// });
